import { PagesPaths } from '@/enums';
import {
  Login,
  SignUp,
  NotFound,
  Contact,
  PrivateHome,
  PublicHome,
  Cfe,
  ActivateUser,
  ForgotPassword,
  ResetPassword,
  Eir,
  SchedulePage,
  CostSimulator,
  UserSettings,
  ContainerList,
  ContainerTap,
  SearchByBooking,
  UnloadingList,
  SOLAS,
  ContainerRelease,
  ExchangesPage,
  NumberStock,
  AssignList,
  DeliveryOrder,
  StockExportContainers,
  StockSummary,
  // LoadForecast,
  DetailedStock,
  CustomerRegistration,
  WorkOrder,
  PaymentInquiry,
  DocumentsWebPage,
  DocumentsHistoryPage,
  MySettlement,
  Depo20,
  ImportFCL,
  VacioImportacion,
  PendingPayments,
  AccountStatement,
  ScheduleDetail,
} from '@/pages';

type RouterType = {
  path: PagesPaths;
  element: JSX.Element;
  name?: string;
  usePrivateLayout?: boolean;
};

export const publicPages: RouterType[] = [
  {
    path: PagesPaths.PublicHome,
    element: <PublicHome />,
  },
  {
    path: PagesPaths.Login,
    element: <Login />,
  },
  {
    path: PagesPaths.SignUp,
    element: <SignUp />,
  },
  {
    path: PagesPaths.ActivateUser,
    element: <ActivateUser />,
  },
  {
    path: PagesPaths.ForgotPassword,
    element: <ForgotPassword />,
  },
  {
    path: PagesPaths.ResetPassword,
    element: <ResetPassword />,
  },
  {
    path: PagesPaths.Contact,
    element: <Contact />,
  },
  {
    path: PagesPaths.EInvoice,
    element: <Cfe />,
    usePrivateLayout: true,
  },
  {
    path: PagesPaths.EIR,
    element: <Eir />,
    usePrivateLayout: true,
  },
  {
    path: PagesPaths.CostSimulator,
    element: <CostSimulator />,
    usePrivateLayout: true,
  },
  {
    path: PagesPaths.NotFound,
    element: <NotFound />,
  },
];

export const privatePages: RouterType[] = [
  {
    path: PagesPaths.PrivateHome,
    element: <PrivateHome />,
  },
  {
    path: PagesPaths.Schedule,
    element: <SchedulePage />,
  },
  {
    path: PagesPaths.Settings,
    element: <UserSettings />,
  },
  {
    path: PagesPaths.ContainerList,
    element: <ContainerList />,
    name: 'Buques_ContainerList',
  },
  {
    path: PagesPaths.ContainerTap,
    element: <ContainerTap />,
    name: 'Contenedores_FichaContenedor',
  },
  {
    path: PagesPaths.SearchByBooking,
    element: <SearchByBooking />,
    name: 'Buques_BusquedaPorBooking',
  },
  {
    path: PagesPaths.UnloadingList,
    element: <UnloadingList />,
    name: 'Buques_ListaDeDescarga',
  },
  {
    path: PagesPaths.SOLAS,
    element: <SOLAS />,
    name: 'Buques_SOLAS',
  },
  {
    path: PagesPaths.ContainerRelease,
    element: <ContainerRelease />,
    name: 'Contenedores_LiberacionImportacion',
  },
  {
    path: PagesPaths.Exchanges,
    element: <ExchangesPage />,
    name: 'Stock_ParteIntercambios',
  },
  {
    path: PagesPaths.NumberStock,
    element: <NumberStock />,
    name: 'Contenedores_NumeroDeStock',
  },
  {
    path: PagesPaths.AssignList,
    element: <AssignList />,
    name: 'Buques_ListaDeAsignacion',
  },
  {
    path: PagesPaths.StockSummary,
    element: <StockSummary />,
    name: 'Stock_ResumenStock',
  },
  {
    path: PagesPaths.DeliveryOrder,
    element: <DeliveryOrder />,
    name: 'Contenedores_DeliveryOrder',
  },
  {
    path: PagesPaths.StockContainers,
    element: <StockExportContainers />,
  },
  /*  {
    path: PagesPaths.PronosticoCarga,
    element: <LoadForecast />,
    name: 'Stock_PronosticoCarga',
  }, */
  {
    path: PagesPaths.DetailedStock,
    element: <DetailedStock />,
  },
  {
    path: PagesPaths.CustomerRegistration,
    element: <CustomerRegistration />,
    name: 'Liquidaciones_AltaTitularNexys',
  },
  {
    path: PagesPaths.OrdenDeTrabajo,
    element: <WorkOrder />,
    name: 'Liquidaciones_GenerarOrdenANPBookin',
  },
  {
    path: PagesPaths.paymentInquiry,
    element: <PaymentInquiry />,
    name: 'Contenedores_ConsultaGastosImportacion',
  },
  {
    path: PagesPaths.documentsWeb,
    element: <DocumentsWebPage />,
    name: 'Liquidaciones_MisDocumentos',
  },
  {
    path: PagesPaths.documentsHistory,
    element: <DocumentsHistoryPage />,
    name: 'Menu_HistoricoDocumentos',
  },
  {
    path: PagesPaths.mySettlement,
    element: <MySettlement />,
    name: 'Liquidaciones_MisLiquidaciones',
  },
  {
    path: PagesPaths.Depo20,
    element: <Depo20 tipo="DEPO20" />,
  },
  {
    path: PagesPaths.ImportFCL,
    element: <ImportFCL tipo="Import" />,
  },
  {
    path: PagesPaths.VacioImportacion,
    element: <VacioImportacion />,
  },
  {
    path: PagesPaths.ServicioAdicional,
    element: <Depo20 tipo="ServicioAdicional" />,
  },
  {
    path: PagesPaths.ExportFCL,
    element: <ImportFCL tipo="Export" />,
  },
  {
    path: PagesPaths.paymentPendings,
    element: <PendingPayments />,
  },

  {
    path: PagesPaths.accountStatement,
    element: <AccountStatement />,
    name: 'Estado_de_Cuenta',
  },
  {
    path: PagesPaths.ScheduleDetail,
    element: <ScheduleDetail />,
  },
];
